module.exports = __webpack_public_path__ + "static/media/signin.f3f97260.png";